"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgIcon_1 = tslib_1.__importDefault(require("@mui/material/SvgIcon"));
const MenuAlarmIcon = (
// Allows the callee to override the default values and pass any additional prop of SvgIcon. See https://material-ui.com/api/svg-icon/
{ titleAccess, fontSize = "small", ...rest }, forwardedRef) => (react_1.default.createElement(SvgIcon_1.default, { ...{ titleAccess, fontSize, ...rest, ref: forwardedRef } },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5ZM13.25 16.7692C13.25 17.4462 12.6875 18 12 18C11.3062 18 10.75 17.4462 10.75 16.7692H13.25ZM15.75 11.2308V14.3077L17 15.5385V16.1538H7V15.5385L8.25 14.3077V11.2308C8.25 9.33539 9.26875 7.76 11.0625 7.34154V6.92308C11.0625 6.41231 11.4813 6 12 6C12.5188 6 12.9375 6.41231 12.9375 6.92308V7.34154C14.725 7.76 15.75 9.34154 15.75 11.2308Z" })));
const IconWithRef = react_1.default.forwardRef(MenuAlarmIcon);
if (process.env.NODE_ENV !== "production") {
    // @ts-ignore: Expose property used for testing
    IconWithRef.Naked = MenuAlarmIcon;
}
exports.default = IconWithRef;
